import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { disableScrolling, enableScrolling } from '../utils/helpers';
import AnchorLinks from './AnchorLinks';

class Menu {
  constructor(wWidth) {
    this.wWidth = wWidth;
    this.$block = $('.menu');
    this.$categories = this.$block.find('.menu__category:not(.is-first)');
    this.$btns = this.$categories.find('.menu__btn');
    this.$menuContent = this.$categories.find('.menu__content');
    this.$dishes = this.$block.find('.menu-dish');
    this.$dietaryMessage = this.$block.find('.menu__dietary-text-cta');
    this.$anchorLinks = this.$block.find('.anchor-links');

    // modal
    this.$allergensBtns = $('a[href="#allergens"]');
    this.$modal = $('.modal');
    this.$modalInner = this.$modal.find('.modal__inner');
    this.$closeBtn = this.$modal.find('.modal__close');
    this.$filterBtns = this.$modal.find('.modal__btn');
    this.$save = this.$modal.find('.modal__save');

    // allergens filters
    this.allergens = [];
    this.dietary = [];

    this.init();
  }

  init() {
    // toggle menu categories
    this.$btns.on('click', (e) => {
      const $cur = $(e.currentTarget);
      const $curCategory = $cur.closest('.menu__category');

      if ($curCategory.hasClass('is-opened')) {
        $curCategory.removeClass('is-opened');
        $curCategory.find('.menu__content').slideUp();
      } else {
        $curCategory.addClass('is-opened');
        $curCategory.find('.menu__content').slideDown();
      }
    });

    // open allergens modal
    this.$allergensBtns.on('click', (e) => {
      e.preventDefault();
      this.openModal();
    });

    // close modal on click outside or close btn
    this.$modal.on('click', this.closeModal.bind(this));
    this.$closeBtn.on('click', this.closeModal.bind(this));

    // prevent modal closing on click inside
    this.$modalInner.on('click', (e) => {
      e.stopPropagation();
    });

    // toggle filter btns
    this.$filterBtns.on('click', (e) => {
      const $cur = $(e.currentTarget);
      $cur.toggleClass('is-active');
    });

    // save filters
    this.$save.on('click', (e) => {
      e.preventDefault();
      this.saveFilters();
      this.closeModal();
    });
  }

  openModal() {
    this.$modal.addClass('is-opened');
    disableScrolling();
  }

  closeModal() {
    this.$modal.removeClass('is-opened');
    enableScrolling();
    this.resetFilters();
  }

  saveFilters() {
    this.dietary = [];
    this.allergens = [];

    // get selected filters
    this.$filterBtns.each((i, el) => {
      const $cur = $(el);
      const isDietary = $cur.hasClass('is-dietary');

      if ($cur.hasClass('is-active')) {
        const value = $cur.data('filter');

        if (isDietary) {
          this.dietary.push(value);
        } else {
          this.allergens.push(value);
        }
      }
    });

    this.filterDishes();

    // show dietary message
    if (this.dietary.length > 0) {
      this.$dietaryMessage.slideDown();
    } else {
      this.$dietaryMessage.slideUp();
    }

    // update scroll trigger
    ScrollTrigger.refresh();
  }

  // filter menu items
  filterDishes() {
    this.$dishes.each((i, el) => {
      const $cur = $(el);
      const $item = $cur.hasClass('menu-grid__copy')
        ? $cur.closest('.menu-grid__item')
        : $cur;
      const allergens = $cur.data('allergens');
      const dietary = $cur.data('dietary');
      let isDietaryMatch = true;
      let isAllergensMatch = true;

      // no filters selected, show all items
      if (!this.dietary.length && !this.allergens.length) {
        $item.removeClass('is-disabled');
        return;
      }

      // if dietary requirement selected, show only items which match
      if (this.dietary.length) {
        if (dietary) {
          const dietaryArr = dietary.split(',');
          const dietaryFound = this.dietary.some(
            (option) => dietaryArr.indexOf(option) !== -1
          );
          isDietaryMatch = dietaryFound;
        } else {
          isDietaryMatch = false;
        }
      }

      // if allergens selected, hide items which match
      if (this.allergens.length) {
        if (allergens) {
          const allergensArr = allergens.split(',');
          const allergensFound = this.allergens.some(
            (option) => allergensArr.indexOf(option) !== -1
          );
          isAllergensMatch = !allergensFound;
        } else {
          isAllergensMatch = false;
        }
      }

      if (!isDietaryMatch || !isAllergensMatch) {
        $item.addClass('is-disabled');
      } else {
        $item.removeClass('is-disabled');
      }
    });
  }

  resetFilters() {
    this.$filterBtns.each((i, el) => {
      const $cur = $(el);
      const isDietary = $cur.hasClass('is-dietary');
      const filter = $cur.data('filter');

      if (isDietary) {
        if (this.dietary.indexOf(filter) !== -1) {
          $cur.addClass('is-active');
        } else {
          $cur.removeClass('is-active');
        }
      } else if (this.allergens.indexOf(filter) !== -1) {
        $cur.addClass('is-active');
      } else {
        $cur.removeClass('is-active');
      }
    });
  }

  clearFilters() {
    this.allergens = [];
    this.dietary = [];

    this.$filterBtns.removeClass('is-active');
    this.$dishes.removeClass('is-disabled');
    this.$dietaryMessage.slideUp();
  }
}

export default Menu;
